import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { Col, Flex, Row } from '@amzn/stencil-react-components/layout';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { Modal } from '@amzn/stencil-react-components/modal';
// import { LeftNavList, LeftNavItem } from '@amzn/stencil-react-components/left-nav';
import { SideNavItems, SideNavItem } from '@amzn/stencil-react-components/side-nav';
import BorderedView from '../../components/common/BorderedView';
import {
  getAllMessageTemplates,
  getMessageTemplateDetails,
  updateMessageContent,
  updateTemplateFormType,
  updateTemplateName,
  updateTemplateSubject,
} from '../../actions/nudgeActions';
import '../../styles/CreateContent.scss';

import { useUserInfo } from '../../hooks/useUserInfo';
import {
  messageTemplateDetailsListSelector,
  messageTemplateListSelector,
} from '../../selectors/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { FormType } from '../../enums/commonEnums';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { Input } from "@amzn/stencil-react-components/input";
import { containsSubstring } from "../../util/commonUtils";

import { IconSearchSmall } from '@amzn/stencil-react-icons';

const TemplateList = ({ isOpen, close }) => {
  const dispatch = useDispatch();
  const userInfo = useUserInfo();
  const messageDetails = useSelector(messageTemplateDetailsListSelector);
  const messageTemplateList = useSelector(messageTemplateListSelector);
  const [isListLoading, setIsListLoading] = useState(false);
  const [isTemplateLoading, setIsTemplateLoading] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState('');
  const [searchText, setSearchText] = useState('');
  const [filteredTemplateList, setFilteredTemplate] = useState(messageTemplateList);

  useEffect(() => {
    setIsListLoading(true);
    (async () => {
      await dispatch(getAllMessageTemplates(userInfo?.selectedAccessGroupName, userInfo?.idToken));
    })();
    setIsListLoading(false);
  }, []);

  const updateMessageTemplateDetails = (templateList) => {
    if (!isEmpty(templateList)) {
      setIsTemplateLoading(true);
      (async () => {
        await dispatch(getMessageTemplateDetails(templateList[0]?.messageTemplateName, userInfo?.idToken));
      }
      )();
      setIsTemplateLoading(false);
    }
  };

  useEffect(
    () => {
      setFilteredTemplate(messageTemplateList);
      updateMessageTemplateDetails(messageTemplateList);
    },
    [messageTemplateList],
  );

  const getMessageDetails = async templateName => {
    setIsTemplateLoading(true);
    await dispatch(getMessageTemplateDetails(templateName, userInfo?.idToken));
    setIsTemplateLoading(false);
  };

  useEffect(
    () => {
      setCurrentTemplate(messageDetails);
    },
    [messageDetails, getMessageDetails],
  );


  const onTemplateSelect = () => {
    const parser = new DOMParser();
    const templateHtml = parser.parseFromString(currentTemplate?.messageHtmlPart, 'text/html');
    const contentDivList = templateHtml.getElementsByTagName('div');
    const contentElements = Array.from(contentDivList).map(div => {
      return {
        id: div?.id || uuid.v4(),
        type: div?.dataType || 'unavailable',
        content: div.innerHTML,
      };
    });
    dispatch(updateTemplateSubject(currentTemplate?.subject));
    dispatch(updateMessageContent(contentElements));
    close();
  };

  const onEditTemplate = () => {
    dispatch(updateTemplateFormType(FormType.EDIT));
    dispatch(updateTemplateName(currentTemplate?.messageTemplateName));
    onTemplateSelect();
  };

  const onTemplateSearch = useCallback(input => {
    const inputText = input;
    setSearchText(inputText);
    const filteredTemplates = messageTemplateList.filter(({ createdBy, messageTemplateName }) =>
      containsSubstring(createdBy, inputText) || containsSubstring(messageTemplateName, inputText)
    );
    setFilteredTemplate(filteredTemplates);
    updateMessageTemplateDetails(filteredTemplates);
  },
    [searchText]
  );

  return (
    <Modal isOpen={isOpen} close={close} minWidth={'50vw'} backgroundColor="neutral0">
      <Col
        backgroundColor="neutral0"
        data-testid="templatesPopover"
        flex={1}
        width="70vw"
        style={{ minHeight: '700px' }}
        padding={'S100'}
      >
        {isListLoading ? <Spinner size={SpinnerSize.Large} /> : null}
        {!isListLoading ? (
          <>
            <Row padding={'7px 12px'}>
              <Text fontWeight={'500'}>Templates</Text>
            </Row>
            <Col padding={'7px 7px'}>
              <Flex flexDirection="row" gridGap="S100">
                <Col width="50%">
                  <Input
                    role="input"
                    id="templateSearch"
                    value={searchText}
                    placeholder={"search by name or created by"}
                    iconLeft={IconSearchSmall}
                    onChange={e => onTemplateSearch(e?.target.value)}
                  />
                </Col>
              </Flex>
            </Col>
            <Row flex={1} gridGap="S200">
              <Col flex maxHeight={'700px'} style={{ overflowY: 'scroll', padding: '10px' }}>
                {!isEmpty(filteredTemplateList) ? (
                  <div className='campaign-step-wrapper'>
                    {filteredTemplateList.map((tmpl, index) => {
                      const subHeader = tmpl.createdBy;
                      return (
                        // <SideNavItem
                        //   key={tmpl.messageTemplateName + index}
                        //   data-testid="left-nav-item"
                        //   statusIconAltText=""
                        //   header={tmpl.messageTemplateName}
                        //   subHeader={`Created by: ${subHeader}`}
                        //   onSelect={() => {
                        //     console.log('tmpl - ', tmpl);
                        //     getMessageDetails(tmpl.messageTemplateName);
                        //     console.log('currentTemplate - ', currentTemplate);
                        //   }}
                        // />

                        <SideNavItem
                          data-testid="left-nav-item"
                          isSelected={currentTemplate.messageTemplateName == tmpl.messageTemplateName}
                          className={(currentTemplate.messageTemplateName == tmpl.messageTemplateName) ? 'camapign-items campaignOption-selected' : 'camapign-items'}
                          onClick={() => {
                            getMessageDetails(tmpl.messageTemplateName);
                          }}
                          key={tmpl.messageTemplateName + index}>
                          <Row css={{ fontWeight: 500, fontSize: '1.125rem', lineHeight: 1.55556 }}>{tmpl.messageTemplateName}</Row>
                          <Row>{`Created by: ${subHeader}`}</Row>
                        </SideNavItem>
                      );
                    })}
                  </div>
                ) : null}
                {isEmpty(filteredTemplateList) ? (
                  <Text color="gray">
                    <FormattedMessage
                      id="app.templatesList.label.noTemplate"
                      defaultMessage="No template found."
                    />
                  </Text>
                ) : null}
              </Col>
              <Col flex={1} backgroundColor="white" alignItems="center">
                {!isTemplateLoading ? (
                  <Col
                    padding={'S200'}
                    alignSelf="flex-start"
                    gridGap={'S300'}
                    flex="1"
                    width={'100%'}
                  >
                    <Col
                      height={'600px'}
                      style={{ overflow: 'auto' }}
                      gridGap={'S100'}
                      justifyContent="stretch"
                    >
                      <Text fontWeight={'bold'}>Preview</Text>
                      <BorderedView borderColor="gray" flex={1} style={{ padding: '10px' }}>
                        <Col
                          className="content-styles default"
                          alignSelf="flex-start"
                          dangerouslySetInnerHTML={{
                            __html: currentTemplate?.messageHtmlPart?.replace(/"/i, ''),
                          }}
                        />
                      </BorderedView>
                    </Col>

                    <Col
                      display="flex"
                      flexDirection="row"
                      gridGap={'S200'}
                      justifyContent="flex-end"
                    >
                      <Button
                        data-testid="edit-button"
                        alignSelf="flex-end"
                        variant="primary"
                        onClick={onEditTemplate}
                      >
                        <FormattedMessage
                          id="app.templatesList.button.edit"
                          defaultMessage="Edit"
                        />
                      </Button>
                      <Button
                        alignSelf="flex-end"
                        variant="primary"
                        onClick={() => {
                          onTemplateSelect({ callback: close });
                        }}
                      >
                        <FormattedMessage
                          id="app.templatesList.button.select"
                          defaultMessage="Copy"
                        />
                      </Button>
                      <Button alignSelf="flex-end" secondary onClick={close}>
                        <FormattedMessage
                          id="app.templatesList.button.close"
                          defaultMessage="Close"
                        />
                      </Button>
                    </Col>
                  </Col>
                ) : null}
                {isTemplateLoading ? (
                  <Col flex={1} justifyContent="center" alignItems="center">
                    <Spinner size={SpinnerSize.Medium} />
                  </Col>
                ) : null}
              </Col>
            </Row>
          </>
        ) : null}
      </Col>
    </Modal>
  );
};

export default TemplateList;
